import React from "react";
import {Link} from "@bonprix/design-system";
import LandmarkAdapter from "@core/scripts/components/landmark-adapter.js";
import {Typography} from "bonprix-design-system";

export default function SustainabilityGoal({introduction, readMoreText, readMoreUrl, productContext}) {
    if (!introduction || !readMoreText || !readMoreUrl) {
        return <></>;
    }

    const sendClickLandmark = () => {
        LandmarkAdapter.sendClickLandmark(`adp_sustainability_goal_statement\\${productContext.itemNumber}`);
    }

    return (
        <Typography>
            {introduction}
            <Link href={readMoreUrl}
                  onClick={() => sendClickLandmark()}
                  arrowPosition={"right"}
                  showArrow>{readMoreText}</Link>
        </Typography>
    );
}